"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _immutable = require("immutable");
var _loading = require("./loading.js");
var _performanceOverview = require("../selectors/performanceOverview.js");
var _users = require("./users.js");
var _luxon = require("luxon");
var _dateTime = require("../helpers/dateTime.js");
var B2b = /*#__PURE__*/_createClass(function B2b(_ref) {
  var _this = this;
  var Organizations = _ref.Organizations,
    MemberGroups = _ref.MemberGroups,
    Assignments = _ref.Assignments,
    Quizzes = _ref.Quizzes,
    ExamTemplates = _ref.ExamTemplates,
    Reports = _ref.Reports,
    Questions = _ref.Questions,
    QuestionBanks = _ref.QuestionBanks,
    Performance = _ref.Performance;
  _classCallCheck(this, B2b);
  this.b2bHookFactoryWithId = function (action, params, id) {
    var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000 * 60 * 60;
    var dispatch = (0, _reactRedux.useDispatch)();
    var key = action.getKey.apply(action, _toConsumableArray(params));
    var loaded = (0, _loading.useIsLoaded)(key);
    var loading = (0, _loading.useIsLoading)(key);
    var stale = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(key, 0) > duration;
    });
    (0, _react.useEffect)(function () {
      if (loading) return;
      if (loaded && !stale) return;
      if (id) dispatch(action.apply(void 0, _toConsumableArray(params)));
    }, [loaded, stale]);
    return loading || !loaded;
  };
  this.b2bHookFactory = function (action) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000 * 60 * 60;
    return function () {
      var organizationId = (0, _reactRedux.useSelector)(function (state) {
        return state.session.get('selected_organization_id');
      });
      return _this.b2bHookFactoryWithId(action, [organizationId], organizationId, duration);
    };
  };
  this.usePerformanceOverviewForUser = function (questionBankId, userId) {
    return (0, _reactRedux.useSelector)(function (state) {
      return (0, _performanceOverview.selectPerformanceOverview)(state, questionBankId, userId);
    });
  };
  this.usePeerStatsForOrganization = function (questionBankId, bankUsage) {
    return (0, _reactRedux.useSelector)(function (state) {
      return (0, _performanceOverview.peerPerformanceByOrg)(state, questionBankId, bankUsage);
    });
  };
  this.useNationalPeerStats = function () {
    return (0, _reactRedux.useSelector)(function (state) {
      return (0, _performanceOverview.nationalPerformance)(state);
    });
  };
  this.useLoadUsageReportsIfNeeded = function (organizationId) {
    return _this.b2bHookFactoryWithId(_this.Reports.reportsFetch, [organizationId], organizationId);
  };
  this.useLoadUsageReportIfNeeded = function (reportId) {
    return _this.b2bHookFactoryWithId(_this.Reports.reportFetch, [reportId], reportId);
  };
  this.useLoadReportMembersIfNeeded = function (reportId, questionBankId) {
    return _this.b2bHookFactoryWithId(_this.Reports.reportUsersFetch, [reportId, questionBankId], reportId);
  };
  this.useLoadB2BMemberGroupIfNeeded = function (classId) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$loadUsers = _ref2.loadUsers,
      loadUsers = _ref2$loadUsers === void 0 ? true : _ref2$loadUsers,
      _ref2$fullMembers = _ref2.fullMembers,
      fullMembers = _ref2$fullMembers === void 0 ? true : _ref2$fullMembers;
    var duration = 1000 * 60 * 60;
    var dispatch = (0, _reactRedux.useDispatch)();
    var key = _this.MemberGroups.memberGroupFetch.getKey({
      memberGroupId: classId,
      loadUsers: loadUsers
    });
    var loaded = (0, _loading.useIsLoaded)(key);
    var loading = (0, _loading.useIsLoading)(key);
    var stale = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(key, 0) > duration;
    });
    (0, _react.useEffect)(function () {
      if (!classId) return;
      if (loading) return;
      if (loaded && !stale) return;
      dispatch(_this.MemberGroups.memberGroupFetch({
        memberGroupId: classId,
        loadUsers: loadUsers,
        fullMembers: fullMembers
      }));
    }, [loadUsers, fullMembers, stale]);
    return loading || !loaded;
  };
  this.useLoadB2BMembersIfNeeded = function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$loadSubscriptio = _ref3.loadSubscriptions,
      loadSubscriptions = _ref3$loadSubscriptio === void 0 ? false : _ref3$loadSubscriptio,
      _ref3$onlyStudents = _ref3.onlyStudents,
      onlyStudents = _ref3$onlyStudents === void 0 ? false : _ref3$onlyStudents,
      _ref3$query = _ref3.query,
      query = _ref3$query === void 0 ? '' : _ref3$query,
      _ref3$pageNumber = _ref3.pageNumber,
      pageNumber = _ref3$pageNumber === void 0 ? 1 : _ref3$pageNumber,
      _ref3$sortKey = _ref3.sortKey,
      sortKey = _ref3$sortKey === void 0 ? '' : _ref3$sortKey,
      _ref3$fullAssociation = _ref3.fullAssociations,
      fullAssociations = _ref3$fullAssociation === void 0 ? false : _ref3$fullAssociation;
    var organizationId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_organization_id');
    });
    var isIframe = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('isIframe');
    });
    var duration = 1000 * 60 * 60;
    var dispatch = (0, _reactRedux.useDispatch)();
    var key = _this.Organizations.organizationMembersFetch.getKey({
      organizationId: organizationId,
      query: query,
      pageNumber: pageNumber
    });
    var loaded = (0, _loading.useIsLoaded)(key);
    var loading = (0, _loading.useIsLoading)(key);

    // Stale after duration (default is one hour)
    var stale = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(key, 0) > duration;
    });
    (0, _react.useEffect)(function () {
      if (loading) return;
      if (loaded && !stale) return;
      if (!sortKey) return;
      if (organizationId) {
        dispatch(_this.Organizations.organizationMembersFetch({
          organizationId: organizationId,
          loadSubscriptions: loadSubscriptions,
          onlyStudents: onlyStudents,
          query: query,
          pageNumber: pageNumber,
          sortKey: sortKey,
          ati: isIframe,
          fullAssociations: fullAssociations
        }));
      }
    }, [query, pageNumber, sortKey, stale]);
    return loading || !loaded;
  };
  this.useLoadB2BMemberGroupUsersIfNeeded = function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$pageNumber = _ref4.pageNumber,
      pageNumber = _ref4$pageNumber === void 0 ? 1 : _ref4$pageNumber,
      _ref4$query = _ref4.query,
      query = _ref4$query === void 0 ? '' : _ref4$query,
      memberGroupId = _ref4.memberGroupId;
    var organizationId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_organization_id');
    });
    var duration = 1000 * 60 * 60;
    var dispatch = (0, _reactRedux.useDispatch)();
    var key = _this.MemberGroups.memberGroupUsersFetch.getKey({
      organizationId: organizationId,
      memberGroupId: memberGroupId,
      pageNumber: pageNumber,
      query: query
    });
    var loaded = (0, _loading.useIsLoaded)(key);
    var loading = (0, _loading.useIsLoading)(key);

    // Stale after duration (default is one hour)
    var stale = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(key, 0) > duration;
    });
    (0, _react.useEffect)(function () {
      if (loading) return;
      if (loaded && !stale) return;
      if (organizationId) {
        dispatch(_this.MemberGroups.memberGroupUsersFetch({
          organizationId: organizationId,
          memberGroupId: memberGroupId,
          pageNumber: pageNumber,
          query: query
        }));
      }
    }, [memberGroupId, pageNumber, query, stale]);
    return loading || !loaded;
  };
  this.useLoadB2BMemberGroupsIfNeeded = function () {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref5$loadUsers = _ref5.loadUsers,
      loadUsers = _ref5$loadUsers === void 0 ? false : _ref5$loadUsers,
      _ref5$query = _ref5.query,
      query = _ref5$query === void 0 ? '' : _ref5$query,
      _ref5$pageNumber = _ref5.pageNumber,
      pageNumber = _ref5$pageNumber === void 0 ? 1 : _ref5$pageNumber,
      _ref5$sortKey = _ref5.sortKey,
      sortKey = _ref5$sortKey === void 0 ? '' : _ref5$sortKey,
      _ref5$organization = _ref5.organization,
      organization = _ref5$organization === void 0 ? false : _ref5$organization;
    var organizationId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_organization_id');
    });
    var duration = 1000 * 60 * 60;
    var dispatch = (0, _reactRedux.useDispatch)();
    var key = _this.MemberGroups.memberGroupsFetch.getKey({
      organizationId: organizationId,
      query: query,
      pageNumber: pageNumber
    });
    var loaded = (0, _loading.useIsLoaded)(key);
    var loading = (0, _loading.useIsLoading)(key);

    // Stale after duration (default is one hour)
    var stale = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(key, 0) > duration;
    });
    (0, _react.useEffect)(function () {
      if (loading) return;
      if (loaded && !stale) return;
      if (!sortKey) return;
      if (organizationId) {
        dispatch(_this.MemberGroups.memberGroupsFetch({
          organizationId: organizationId,
          loadUsers: loadUsers,
          organization: organization,
          query: query,
          pageNumber: pageNumber,
          sortKey: sortKey
        }));
      }
    }, [query, pageNumber, sortKey, stale]);
    return loading || !loaded;
  };
  this.useLoadTemplateQuestions = function (questionBankId) {
    var dispatch = (0, _reactRedux.useDispatch)();
    var currentUserId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('current_user_id');
    });
    var loadingQuestionBank = (0, _loading.useIsLoading)(_this.QuestionBanks.questionBankSelect, questionBankId, currentUserId);
    var selectedQuestionBankId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_question_bank_id');
    });
    var questionsOnTemplatesBankId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('questions_on_templates_bank_id');
    });
    var questionBankSelected = selectedQuestionBankId === questionBankId;
    var loadingQuestionOnTemplates = (0, _loading.useIsLoading)(_this.ExamTemplates.questionsOnTemplates, questionBankId);
    var newBank = questionsOnTemplatesBankId !== questionBankId;
    var subjectsLoaded = (0, _loading.useIsLoaded)(_this.QuestionBanks.questionBankFetchSubjects, questionBankId, currentUserId);
    var performanceLoaded = (0, _loading.useIsLoaded)(_this.Performance.performanceQuestionsFetch, questionBankId, currentUserId);
    (0, _react.useEffect)(function () {
      if (questionBankId && !questionBankSelected && !loadingQuestionBank) {
        dispatch(_this.QuestionBanks.questionBankSelect(questionBankId, currentUserId));
      }
      if (questionBankId && newBank && !loadingQuestionOnTemplates) {
        dispatch(_this.ExamTemplates.questionsOnTemplates(questionBankId));
      }
    });
    return loadingQuestionBank || questionBankId !== 0 && (newBank || !performanceLoaded || !subjectsLoaded);
  };
  this.useLoadAdaptiveQuestions = function (questionBankId) {
    var dispatch = (0, _reactRedux.useDispatch)();
    var currentUserId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('current_user_id');
    });
    var loadingQuestionBank = (0, _loading.useIsLoading)(_this.QuestionBanks.questionBankSelect, questionBankId, currentUserId);
    var selectedQuestionBankId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_question_bank_id');
    });
    var questionBankSelected = selectedQuestionBankId === questionBankId;
    (0, _react.useEffect)(function () {
      if (questionBankId && !questionBankSelected && !loadingQuestionBank) {
        dispatch(_this.QuestionBanks.questionBankSelect(questionBankId));
      }
    });
    return loadingQuestionBank;
  };
  this.useLoadExcerptsQuestions = function (questionBankId) {
    var dispatch = (0, _reactRedux.useDispatch)();
    var loadingQuestionExcerpts = (0, _loading.useIsLoading)(_this.Questions.questionExcerptsFetch, questionBankId);
    var loadedQuestionExcerpts = (0, _loading.useIsLoaded)(_this.Questions.questionExcerptsFetch, questionBankId);
    var selectedQuestionBankId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_question_bank_id');
    });
    var questionBankSelected = selectedQuestionBankId === questionBankId;
    (0, _react.useEffect)(function () {
      if (!questionBankId) return;
      if (!questionBankSelected) {
        dispatch(_this.QuestionBanks.questionBankSelect(questionBankId));
      }
      if (questionBankId && !loadingQuestionExcerpts && questionBankSelected && !loadedQuestionExcerpts) {
        dispatch(_this.Questions.questionExcerptsFetch(questionBankId));
      }
    }, [questionBankSelected]);
    return questionBankId !== 0 && !loadedQuestionExcerpts;
  };
  this.useLoadExamTemplateIfNeeded = function (examTemplateId) {
    var dispatch = (0, _reactRedux.useDispatch)();
    var examTemplate = (0, _reactRedux.useSelector)(function (state) {
      return state.examTemplates.get(examTemplateId);
    });
    var loadedTemplate = examTemplate && (examTemplate === null || examTemplate === void 0 ? void 0 : examTemplate.get('updated_at')) !== 0;
    var loadingExamTemplate = (0, _loading.useIsLoading)(_this.ExamTemplates.examTemplateFetch, examTemplateId);
    (0, _react.useEffect)(function () {
      if (examTemplateId && !loadedTemplate && !loadingExamTemplate) {
        dispatch(_this.ExamTemplates.examTemplateFetch(examTemplateId));
      }
    }, [loadedTemplate]);
    if (examTemplateId === 0) return false;
    return !loadedTemplate || loadingExamTemplate;
  };
  this.useLoadCreateAssignmentIfNeeded = function (examTemplateId) {
    var loadingAssignments = _this.useLoadB2BAssignmentsIfNeeded();
    var loadingExamTemplates = _this.useLoadB2BExamTemplatesIfNeeded();
    var examTemplate = (0, _reactRedux.useSelector)(function (state) {
      return state.examTemplates.get(examTemplateId);
    });
    var questionBankId = examTemplate === null || examTemplate === void 0 ? void 0 : examTemplate.get('question_bank_id');
    var loadingQuestionBank = _this.useLoadTemplateQuestions(questionBankId);
    return loadingAssignments || loadingExamTemplates || loadingQuestionBank;
  };
  this.useLoadAssignmentIfNeeded = function (assignmentId) {
    var dispatch = (0, _reactRedux.useDispatch)();
    var assignment = (0, _reactRedux.useSelector)(function (state) {
      return state.assignments.get(assignmentId);
    });
    var users = (0, _reactRedux.useSelector)(function (store) {
      return store.users;
    });
    var currentUserId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('current_user_id');
    });
    var groups = (0, _reactRedux.useSelector)(function (store) {
      return store.memberGroups;
    });
    var assignmentUserIds = assignment ? assignment.get('user_ids').toArray().filter(function (id) {
      return id !== currentUserId;
    }) : [];
    var loadedRecipients = assignment ? assignmentUserIds.length <= users.size - 1 && assignment.get('member_group_ids').size <= groups.size : false;
    var loadedAssignment = (0, _loading.useIsLoaded)(_this.Assignments.assignmentFetch, assignmentId);
    var loadingAssignment = (0, _loading.useIsLoading)(_this.Assignments.assignmentFetch, assignmentId);
    (0, _react.useEffect)(function () {
      if (assignmentId && (!loadedAssignment || !loadedRecipients) && !loadingAssignment) {
        dispatch(_this.Assignments.assignmentFetch(assignmentId));
      }
    }, [loadedAssignment]);
    var examTemplateId = assignment === null || assignment === void 0 ? void 0 : assignment.get('exam_template_id');
    var loadedExamTemplate = (0, _loading.useIsLoaded)(_this.ExamTemplates.examTemplateFetch, examTemplateId) || assignment && !examTemplateId;
    var loadingExamTemplate = (0, _loading.useIsLoading)(_this.ExamTemplates.examTemplateFetch, examTemplateId);
    (0, _react.useEffect)(function () {
      if (examTemplateId && !loadedExamTemplate && !loadingExamTemplate) {
        dispatch(_this.ExamTemplates.examTemplateFetch(examTemplateId));
      }
    }, [examTemplateId]);
    return !loadedExamTemplate || !loadedAssignment || loadingAssignment || !loadedRecipients || !loadedExamTemplate;
  };
  this.useSelectedOrganizationQuestionBankIds = function () {
    var _ref6, _ref6$find, _ref6$find$get;
    var selectedOrganizationId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_organization_id');
    });
    var selectedOrgSPOIds = (_ref6 = (0, _reactRedux.useSelector)(function (state) {
      return state.organizations;
    })) === null || _ref6 === void 0 ? void 0 : (_ref6$find = _ref6.find(function (org) {
      return org.get('id') === selectedOrganizationId;
    })) === null || _ref6$find === void 0 ? void 0 : (_ref6$find$get = _ref6$find.get('student_purchase_option_ids')) === null || _ref6$find$get === void 0 ? void 0 : _ref6$find$get.toList().toArray();
    var organizationalSubscriptions = (0, _reactRedux.useSelector)(function (state) {
      return state.organizationalSubscriptions;
    }).filter(function (sub) {
      return sub.get('organization_ids').includes(selectedOrganizationId) && (0, _dateTime.transformToDateTime)(sub.get('expiry_date')) > _luxon.DateTime.now();
    });
    var studentPurchaseOptions = (0, _reactRedux.useSelector)(function (state) {
      return state.products;
    }).filter(function (product) {
      return product.get('student_purchase_option') === true && (selectedOrgSPOIds === null || selectedOrgSPOIds === void 0 ? void 0 : selectedOrgSPOIds.includes(product.get('id')));
    });
    var organizationalSubscriptionsQBIds = new _immutable.Set(organizationalSubscriptions.toList().flatMap(function (sub) {
      return sub.get('question_bank_ids');
    }));
    var studentPurchaseOptionsQBIds = new _immutable.Set(studentPurchaseOptions.toList().flatMap(function (sub) {
      return sub.get('question_bank_ids');
    }));
    return new _immutable.Set([].concat(_toConsumableArray(organizationalSubscriptionsQBIds), _toConsumableArray(studentPurchaseOptionsQBIds)));
  };
  this.useSelectedOrganizationTutorModeEnabled = function () {
    return (0, _reactRedux.useSelector)(function (state) {
      return state.organizations.getIn([state.session.get('selected_organization_id'), 'tutor_mode'], false);
    });
  };
  this.useLoadAssignmentsIfNeeded = function () {
    var loadingTemplatesList = _this.useLoadB2BExamTemplatesIfNeeded();
    var loadingAssignmentsList = _this.useLoadB2BAssignmentsIfNeeded();
    return loadingTemplatesList || loadingAssignmentsList;
  };
  this.useLoadAssignmentsPerformance = function (assignmentId) {
    var dispatch = (0, _reactRedux.useDispatch)();
    var organizationId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_organization_id');
    });
    var loadingAssignment = _this.useLoadAssignmentIfNeeded(assignmentId);
    var _ref7 = (0, _react.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      loadingAssignmentQuizzes = _ref8[0],
      setLoadingAssignmentQuizzes = _ref8[1];
    var _ref9 = (0, _react.useState)(false),
      _ref10 = _slicedToArray(_ref9, 2),
      loadingAssignmentUsers = _ref10[0],
      setLoadingAssignmentUsers = _ref10[1];
    var assignment = (0, _reactRedux.useSelector)(function (state) {
      return state.assignments.get(assignmentId);
    });
    var examTemplate = (0, _reactRedux.useSelector)(function (state) {
      return state.examTemplates.get(assignment === null || assignment === void 0 ? void 0 : assignment.get('exam_template_id'));
    });
    var questionBankId = (examTemplate === null || examTemplate === void 0 ? void 0 : examTemplate.get('question_bank_id')) || (assignment === null || assignment === void 0 ? void 0 : assignment.get('question_bank_id'));
    var isAdaptive = assignment === null || assignment === void 0 ? void 0 : assignment.get('is_adaptive');
    var loadingTemplate = _this.useLoadTemplateQuestions(questionBankId);
    (0, _react.useEffect)(function () {
      if (organizationId) {
        dispatch(_this.Assignments.assignmentQuizzesFetch(assignmentId));
        dispatch(_this.Assignments.assignmentUsersFetch(assignmentId));
      }
    }, [organizationId]);
    var assignmentQuizzesLoaded = (0, _loading.useIsLoaded)(_this.Assignments.assignmentQuizzesFetch, assignmentId);
    var assignmentUsersLoading = (0, _loading.useIsLoaded)(_this.Assignments.assignmentUsersFetch, assignmentId);
    (0, _react.useEffect)(function () {
      setLoadingAssignmentQuizzes(assignmentQuizzesLoaded);
      setLoadingAssignmentUsers(assignmentUsersLoading);
    }, [assignmentQuizzesLoaded, assignmentUsersLoading]);
    return loadingAssignment || !loadingAssignmentUsers || !loadingAssignmentQuizzes || !isAdaptive && loadingTemplate;
  };
  this.useLoadQuizResponses = function (quizId) {
    return _this.b2bHookFactoryWithId(_this.Quizzes.quizFetchResponses, [quizId], quizId);
  };
  this.useAssignmentQuizzesandSubjects = function (completedQuizzes, examTemplate, isAdaptive, isAact) {
    var responses = (0, _reactRedux.useSelector)(function (state) {
      return state.responses;
    });
    var questions = (0, _reactRedux.useSelector)(function (state) {
      return state.performanceQuestions;
    });
    var subjects = (0, _reactRedux.useSelector)(function (state) {
      return state.subjects;
    });
    var assignmentQuestionIds = (0, _react.useMemo)(function () {
      return examTemplate ? examTemplate.get('question_ids').toArray() : [];
    }, [examTemplate]);
    var quizAndSubjectData = (0, _react.useMemo)(function () {
      if (completedQuizzes.size === 0 || questions.size === 0 || subjects.size === 0 || !isAdaptive && assignmentQuestionIds.length === 0) return null;
      var data = {
        quizData: {
          scores: [],
          times: []
        },
        subjectData: {}
      };
      completedQuizzes.forEach(function (quiz) {
        var quizResponses = responses.filter(function (r) {
          return r.get('quiz_id') === quiz.get('id');
        });
        var correctResponses = 0;
        var times = [];
        var unansweredQuestions = _toConsumableArray(assignmentQuestionIds);
        // add actions for subject data when iterating through responses
        quizResponses.forEach(function (r) {
          var questionId = r.get('question_id');
          var idIndex = unansweredQuestions.findIndex(function (id) {
            return id === questionId;
          });
          if (!isAdaptive) unansweredQuestions.splice(idIndex, 1);
          if (r.get('status') === "C") correctResponses += 1;
          var question = questions.get(questionId);
          if (question) {
            question.get('subjectIds', new _immutable.List()).forEach(function (subjectId) {
              var subject = subjects.get(subjectId);
              if (!subject) return;
              if (data.subjectData[subjectId] === undefined) {
                data.subjectData[subjectId] = {
                  subjectResponses: [r],
                  times: [r.get('time')]
                };
              } else {
                data.subjectData[subjectId].subjectResponses.push(r);
                if (data.subjectData[subjectId].times !== undefined) {
                  data.subjectData[subjectId].times.push(r.get('time'));
                } else {
                  data.subjectData[subjectId].times = [r.get('time')];
                }
              }
            });
          }
          times.push(r.get('time'));
        });
        if (isAact) {
          data.quizData.scores.push(quiz.get('actual_score') / quiz.get('potential_score') * 100);
        } else {
          data.quizData.scores.push(correctResponses / quiz.get('total_questions') * 100);
        }
        var averageResponseTime = times.reduce(function (prev, curr) {
          return prev + curr;
        }, 0) / quiz.get('total_questions');
        data.quizData.times.push(averageResponseTime);

        // check for unanswered questions and add that data to subject output.
        if (!isAdaptive && unansweredQuestions.length > 0) {
          unansweredQuestions.forEach(function (qid) {
            var question = questions.get(qid);
            if (question) {
              question.get('subjectIds', new _immutable.List()).forEach(function (subjectId) {
                var subject = subjects.get(subjectId);
                if (!subject) return;
                if (data.subjectData[subjectId] === undefined) {
                  data.subjectData[subjectId] = {
                    subjectResponses: [(0, _immutable.Map)({
                      status: 'U'
                    })]
                    // I didn't put any times here because I figured that unanswered questions should not be factored into the time.
                    // Since there is no response, I am not really sure we could anyway.
                  };
                } else {
                  data.subjectData[subjectId].subjectResponses.push((0, _immutable.Map)({
                    status: 'U'
                  }));
                }
              });
            }
          });
        }
      });
      return data;
    }, [completedQuizzes, responses, questions, subjects, assignmentQuestionIds]);
    var _ref11 = (0, _react.useState)(null),
      _ref12 = _slicedToArray(_ref11, 2),
      returnValue = _ref12[0],
      setReturnValue = _ref12[1];
    (0, _react.useEffect)(function () {
      if (quizAndSubjectData !== null) {
        setReturnValue(_objectSpread({}, quizAndSubjectData));
      }
    }, [quizAndSubjectData, completedQuizzes]);
    return returnValue;
  };
  this.useOrgRoles = function (organizationId) {
    var users = (0, _reactRedux.useSelector)(function (state) {
      return state.users;
    });
    var memberships = (0, _reactRedux.useSelector)(function (state) {
      return state.organizationalMemberships;
    });
    var orgMemberships = (0, _react.useMemo)(function () {
      return memberships.filter(function (membership) {
        return membership.get('organization_id') === organizationId && membership.get('deactivated') === false && membership.get('verified') === true;
      });
    }, [memberships]);
    var orgIds = (0, _react.useMemo)(function () {
      return orgMemberships.groupBy(function (om) {
        return om.get('user_id');
      }).keySeq().toArray();
    }, [orgMemberships]);
    var orgUsers = (0, _react.useMemo)(function () {
      return users.filter(function (u) {
        return orgIds.includes(u.get('id'));
      });
    }, [users, orgIds]);
    var _ref13 = (0, _react.useState)([]),
      _ref14 = _slicedToArray(_ref13, 2),
      delegateUsers = _ref14[0],
      setDelegateUsers = _ref14[1];
    var _ref15 = (0, _react.useState)([]),
      _ref16 = _slicedToArray(_ref15, 2),
      studentUsers = _ref16[0],
      setStudentUsers = _ref16[1];
    (0, _react.useEffect)(function () {
      setStudentUsers([]);
      setDelegateUsers([]);
      orgUsers.forEach(function (user) {
        var membership = memberships.filter(function (m) {
          return m.get('user_id') === user.get('id');
        }).first();
        var role = membership.get("role");
        if (role === "student") {
          setStudentUsers(function (prev) {
            return [].concat(_toConsumableArray(prev), [user]);
          });
        } else {
          setDelegateUsers(function (prev) {
            return [].concat(_toConsumableArray(prev), [user]);
          });
        }
      });
    }, [orgUsers, memberships]);
    return {
      studentUsers: (0, _immutable.List)(studentUsers),
      delegateUsers: (0, _immutable.List)(delegateUsers),
      orgMemberships: orgMemberships
    };
  };
  this.useLoadB2BStaffOrganizationsIfNeeded = function () {
    var currentUser = (0, _users.useCurrentUser)();
    var staffOrganizationalMemberships = (0, _reactRedux.useSelector)(function (state) {
      return state.organizationalMemberships;
    }).filter(function (org) {
      return org.get('role') === 'admin' || org.get('role') === 'instructor' || org.get('role') === 'super admin';
    });
    var isAdmin = currentUser.get('internal_role') === 'admin';
    var isDistributor = currentUser.get('internal_role') === 'distributor';
    var dispatch = (0, _reactRedux.useDispatch)();
    var key = _this.Organizations.organizationsFetch.getKey();
    var loaded = (0, _loading.useIsLoaded)(key);
    var loading = (0, _loading.useIsLoading)(key);
    var stale = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(key, 0) > 1000 * 60 * 60;
    });
    (0, _react.useEffect)(function () {
      if (loading) return;
      if (loaded && !stale) return;
      dispatch(_this.Organizations.organizationsFetch());
    }, [loaded, stale]);
    if (staffOrganizationalMemberships.size < 1 && (!isAdmin || !isDistributor)) return false;
    return loading || !loaded;
  };
  this.useOrganizationHasAdaptive = function (organizationId) {
    var organizations = (0, _reactRedux.useSelector)(function (state) {
      return state.organizations;
    });
    var organizationalSubscriptions = (0, _reactRedux.useSelector)(function (state) {
      return state.organizationalSubscriptions;
    });
    var questionBanks = (0, _reactRedux.useSelector)(function (state) {
      return state.questionBanks;
    });
    var organization = organizations.get(organizationId);
    var selectedOrganizationalSubscriptions = organization === null || organization === void 0 ? void 0 : organization.get('organizational_subscription_ids').toArray();
    if (!organizationId) return false;
    if (!selectedOrganizationalSubscriptions || selectedOrganizationalSubscriptions.length === 0) return false;

    //  check each organizational subscription for adaptive banks
    var hasAdaptive = false;
    var orgSubIndex = 0;
    while (!hasAdaptive) {
      //  if we have hit execceeded the list length break loop
      if (orgSubIndex === selectedOrganizationalSubscriptions.length) break;

      // get org subscription question bank ids
      var orgSub = organizationalSubscriptions === null || organizationalSubscriptions === void 0 ? void 0 : organizationalSubscriptions.get(selectedOrganizationalSubscriptions[orgSubIndex]);
      var questionBankIds = orgSub === null || orgSub === void 0 ? void 0 : orgSub.get('question_bank_ids').toArray();
      if (questionBankIds) {
        var questionBankIdIndex = 0;
        while (!hasAdaptive) {
          //  if we have hit exceeded the list length break loop
          if (questionBankIdIndex === questionBankIds.length) break;

          // get the question bank from the id and check if it is adaptive, if it is break the loop, if not continue on.
          var questionBank = questionBanks.get(questionBankIds[questionBankIdIndex]);
          hasAdaptive = questionBank !== null && questionBank !== void 0 && questionBank.get('adaptive_available') ? questionBank.get('adaptive_available') : false;
          questionBankIdIndex += 1;
        }
      }
      orgSubIndex += 1;
    }
    return hasAdaptive;
  };
  this.Organizations = Organizations;
  this.MemberGroups = MemberGroups;
  this.Assignments = Assignments;
  this.Quizzes = Quizzes;
  this.ExamTemplates = ExamTemplates;
  this.Reports = Reports;
  this.Questions = Questions;
  this.QuestionBanks = QuestionBanks;
  this.Performance = Performance;
  this.useLoadB2BOrganizationIfNeeded = this.b2bHookFactory(this.Organizations.organizationFetch);
  this.useLoadB2BAssignmentsIfNeeded = this.b2bHookFactory(this.Assignments.assignmentsListFetch);
  this.useLoadB2BExamTemplatesIfNeeded = this.b2bHookFactory(this.ExamTemplates.examTemplatesListFetch);
  this.useLoadQuestionBanksNames = this.b2bHookFactory(this.QuestionBanks.getQuestionBankNames);
});
var _default = exports.default = B2b;